export default __webpack_public_path__ + "static/media/satisfaccion.34e9f316.png";